import Head from 'next/head'

const Meta = () => (
  <Head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta charSet="utf-8" />
    <link rel="shortcut icon" href="/static/minted.ico" />
    <link rel="stylesheet" type="text/css" href="/static/nprogress.css" />
  </Head>
)

export default Meta
